module.exports = __webpack_public_path__ + "img/fi-rr-playing-cards.a1da06fb.svg";